import { logger } from "logging";
import { getCookie } from "./utils/cookie";
import { isServer } from "./utils/isServer";

/**
 * replace object values with string
 * @param vernacularString - string where values have to be replaced
 * @param params - object values to replace
 * @returns string
 */
 export const stringInterpolation = (vernacularString: string, params: Record<string, any>) => {
  try {
    Object.keys(params).forEach(x => {
      vernacularString = vernacularString.replace(`{${x}}`, params[x]?.toString());
    });
    if (vernacularString.includes("{") || vernacularString.includes("}")) {
      return "";
    }
    return vernacularString;
  } catch (error) {
    logger.error(error as Error, "Error while string interpolation");
  }
  return "";
};

//returns string based on params passed
//this function does not take vernacular IDS but Values
export const getVernacularString = (vernacularString: string, fallback: string, params?: Record<string, any>) => {
  try {
    if (!vernacularString) {
      return fallback;
    }
    const bracesRegex = /\{.*\}/;
    const testRegexp = new RegExp(bracesRegex);
    if (testRegexp.test(vernacularString)) {
      if (params) {
        const str = stringInterpolation(vernacularString, params);
        if (str) {
          return str;
        }
        return fallback;
      }
    } else {
      return vernacularString;
    }
  } catch (error) {
    logger.error(error as Error, "Error in getting getVernacularString");
  }

  return fallback;
};

export const getVernacularData = () => {
    const vernacularData = {
        isExperimentEnabled: false,
        allMessages: {
        "en": {},
        "hi": {},
        },
        language: "en",
    };
    try {
        if (!isServer()) {
        const langConfig = (window as any)?.langConfig;
        const allMessages = langConfig?.strings;
        const language = langConfig?.lang;
        const langExperiment = langConfig?.isExperimentEnabled;
        if (allMessages && Object.keys(allMessages).length && language) {
            vernacularData.allMessages = allMessages,
            vernacularData.language = language;
            vernacularData.isExperimentEnabled = langExperiment;
        }
        }
    } catch (error) {
        logger.error(error, "Error in getVernacularData");
    }

    return vernacularData;
};

export const getVernacularStringByLang = () => {
    let vernacularStrings = {};
    try {
        if (!isServer()) {
            const langConfig = (window as any)?.langConfig;
            const language = langConfig?.lang;
            if (langConfig && Object.keys(langConfig).length && language) {
              vernacularStrings = langConfig?.strings?.[language];
            }
        }
    } catch (error) {
        logger.error(error, "Error in getVernacularStringByLang");
    }

    return vernacularStrings;
};

export const getCurrentLangStrings = () => {
  try {
    if (!isServer()) {
      const cookieLang = getCookie("lang");
      const langConfig = (window as any)?.langConfig;
      const allMessages = langConfig?.strings;
      if (cookieLang && allMessages) {
        const messages = allMessages?.[cookieLang];
        if (messages) {
          return messages;
        }
      }
    }
  } catch (error) {
        logger.error(error, "Error in getCurrentLangStrings");
  }

  return {};
};

/**
 * getCurrentLanguage is function which returns current language is set
 * @returns current lang cookie value
 */

export const getCurrentLanguage = () => {
  try {
    if (!isServer()) {
      const cookieLang = getCookie("lang");
      const langConfig = (window as any)?.langConfig;
      const language = langConfig?.lang;
      if (cookieLang && language) {
        return language;
      }
    }
  } catch (error) {
        logger.error(error, "Error in getCurrentLanguage");
  }

  return "en";
};

/**
 * This function gets the vernacularString from language config
 */
export const getStringFromId = (vernacularString: string, fallback: string, params?: Record<string, any>) => {
      const getStringFromLangConfig = (window as any)?.langConfig?.strings[(window as any)?.langConfig?.lang || "en"][vernacularString];
      return getVernacularString(getStringFromLangConfig, fallback, params);
};
